import { Component, Injectable, OnInit, OnDestroy } from '@angular/core';
import { AuthenticateService } from '../../../common/services/Authenticate.service';
import { ModalInfoService } from '../../../common/services/ModalInfo.service';
import { EvsAddressService } from '../../../common/services/EvsAddress.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';

/**
 * This class represents the lazy loaded HomeComponent.
 */
declare var $: any;

@Component({
  selector: 'app-register',
  templateUrl: 'register-v3.component.html',
  styleUrls: ['./register.css'],
  providers: [EvsAddressService],
})
@Injectable()
export class RegisterComponent implements OnInit, OnDestroy {
  public model: any = {};
  public message: any; //{ class: string, content: string }
  public check: boolean = false;
  public cities: Array<any> = [];
  public districts: Array<any> = [];
  public FormRegister: FormGroup;
  public langSubscription: Subscription;
  public placeholders: any = {};
  public currentLang: string = 'vi';

  // public message: { class: string; content: string } = null;

  constructor(
    private mdInfo: ModalInfoService,
    private authenService: AuthenticateService,
    // private _flashMessagesService: FlashMessagesService,
    public addressService: EvsAddressService,
    private fb: FormBuilder,
    private translate: TranslateService
  ) {
    let body = document.getElementsByTagName('body')[0];
    body.classList.add('animsition'); //add the class
    body.classList.add('layout-full'); //add the class
  }

  ngOnInit() {
    // this.createForm();
    this.currentLang = this.translate.currentLang || 'vi';
    this.updatePlaceholders();
    this.langSubscription = this.translate.onLangChange.subscribe((event: any) => {
      this.currentLang = event.lang;
      this.updatePlaceholders();
    });

    this.getCity();
    var that = this;
    $('#city').select2({
      placeholder: '-- Chọn Tỉnh/TP --',
      allowClear: false,
    });
    $('#district').select2({
      placeholder: '-- Chọn Quận/Huyện --',
      allowClear: false,
    });
    $('#city').on('select2:select', function (e) {
      $('.select2-selection__rendered').removeAttr('title');
      var id = e.target.value;
      that.loadDistrictData(id);
    });
    $('#district').on('select2:select', function (e) {
      $('.select2-selection__rendered').removeAttr('title');
    });
  }

  createForm() {
    this.FormRegister = this.fb.group({
      username: [null, Validators.required],
      password: [null, Validators.required],
      confirm_password: [null, Validators.required],
      name: [null],
      address: [null],
      district_id: [null],
      city_id: [null],
      phone: [null],
      emmail: [null],
      website: [null],
      tax: [null],
      cmt: [null],
    });
  }

  updatePlaceholders() {
    this.translate.get([
      'RV_NHAP_TEN_DN_CA_NHAN',
      'RV_NHAP_SDT',
      'RV_NHAP_MA_SO_THUE',
      'RV_NHAP_SO_CCCD_CMND',
      'RV_NHAP_SDT_LIEN_LAC',
      'RV_NHAP_DIA_CHI_EMAIL',
      'RV_NHAP_LINK_WEBSITE',
      'RV_NHAP_DIA_CHI_CHI_TIET',
      'RV_CHON_TINH_TP',
      'RV_CHON_QUAN_HUYEN',
    ]).subscribe((t: any) => {
      this.placeholders = {
        name: t['RV_NHAP_TEN_DN_CA_NHAN'],
        phone: t['RV_NHAP_SDT'],
        tax: t['RV_NHAP_MA_SO_THUE'],
        cmt: t['RV_NHAP_SO_CCCD_CMND'],
        tel: t['RV_NHAP_SDT_LIEN_LAC'],
        email: t['RV_NHAP_DIA_CHI_EMAIL'],
        website: t['RV_NHAP_LINK_WEBSITE'],
        address: t['RV_NHAP_DIA_CHI_CHI_TIET'],
        city: t['RV_CHON_TINH_TP'],
        district: t['RV_CHON_QUAN_HUYEN'],
      };

      // Update select2 placeholders dynamically
      $('#city').select2({
        placeholder: this.placeholders.city,
        allowClear: false,
      });
      $('#district').select2({
        placeholder: this.placeholders.district,
        allowClear: false,
      });
    });
  }

  keyPressEvent(event: KeyboardEvent) {
    const pattern = /^[a-zA-Z]+(-_ [a-zA-Z]+)*/
    const specialChars = /[~`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (specialChars.test(inputChar) || pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  onSubmit(data) {
    this.message = null;
    console.log('data', data);
    const body = {
      name: data.name,
      phone: data.tel,
      email: data.email,
      address: data.address,
      website: data.website,
      tax: data.tax,
      cmt: data.cmt,
      city_id: data.city_id,
      district_id: data.district_id,
      icheck_phone: data.phone,
    }

    this.authenService
      .register(body)
      .toPromise()
      .then((res) => {
        if (res.code == 1) {
          this.message = {
            class: 'alert-success',
            content: this.translate.instant('RV_DANG_KY_THANH_CONG_CHO_DUYET'),
          };
          console.log(this.message);
        } else {
          // If the backend returns a Vietnamese error, ideally it should be translated as well. But res.message is dynamic.
          this.message = { class: 'alert-danger', content: res.message };
          console.log('register:error');
        }
      })
      .catch((err: any) => {
        this.message = { class: 'alert-danger', content: err.message };
        console.log('register:catch');
      });
  }

  getCity() {
    this.addressService.getCities().subscribe((res) => {
      const citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.id,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;
    });
  }

  loadDistrictData(id: number) {
    this.addressService
      .getDistrict({ city_id: id })
      .toPromise()
      .then((res) => {
        let districts = [];
        res.data.districts.forEach((c: any) => {
          districts.push({
            value: c.id,
            label: c.name,
            id: c.id,
          });
        });
        this.districts = districts;
      });
  }

  changeLanguage(lang: string) {
    this.translate.use(lang);
  }

  ngOnDestroy() {
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/auth/register.component.ts